export const DATE_RANGE_PRESETS = [
  '30d',
  '60d',
  '90d',
  '180d',
  'custom',
] as const;

export type DateRangePreset = (typeof DATE_RANGE_PRESETS)[number];

export const DEFAULT_DATE_RANGE_PRESET: DateRangePreset = '90d';
